import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-400cb1b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "text-section__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "text-section",
    title: _ctx.title
  }, {
    buttons: _withCtx(() => [
      _createVNode(_component_IconButton, {
        hint: "Edit",
        type: "EditIcon",
        variant: "transparent",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMode = true))
      })
    ]),
    content: _withCtx(() => [
      (!_ctx.editMode)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.modelValue || _ctx.$t("click-edit-to-add-text")), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _withDirectives(_createElementVNode("textarea", {
          ref: "textarea",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tmpValue) = $event)),
          placeholder: _ctx.$t('click-here-to-write-text'),
          class: "text-section__textarea"
        }, null, 8, _hoisted_2), [
          [_vModelText, _ctx.tmpValue]
        ]),
        _createElementVNode("nav", _hoisted_3, [
          _createVNode(_component_Button, {
            secondary: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editMode = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ui-cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, { onClick: _ctx.save }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ui-save")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.editMode]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}